import Extend from 'flarum/common/extenders';
import app from 'flarum/forum/app';
import commonExtend from '../common/extend';
import ExhibitionsListPage from './components/ExhibitionsListPage';
import ExhibitionPage from './components/ExhibitionPage';
import SocietyPage from './components/SocietyPage';
import CartothequePage from './components/CartothequePage';
import CartothequeEntryDescriptionPage from './components/CartothequeEntryDescriptionPage';
import ExpoPage from './components/ExpoPage';
export default [...commonExtend, new Extend.Routes().add('exhibitions', '/exhibitions', ExhibitionsListPage).add('exhibition', '/exhibitions/:id', ExhibitionPage).helper('exhibition', id => app.route('exhibition', {
  id
}))
// No top-level 'societies' list route anymore - ExhibitionsListPage
// itself now lists every société, each linking into its own
// /societies/:id for management (toxicités/mise en page des cartes).
.add('society', '/societies/:id', SocietyPage).helper('society', id => app.route('society', {
  id
}))
// Split out of SocietyPage per explicit feedback - its own page so it
// can be linked directly from ExhibitionPage too (creating a card on
// the spot while logging a finding that isn't carded yet).
.add('cartotheque', '/societies/:id/cartotheque', CartothequePage).helper('cartotheque', id => app.route('cartotheque', {
  id
}))
// What a card's printed QR code links to - see CardPdfBuilder and
// CartothequeEntryDescriptionPage's own docblock for why this route,
// uniquely in this extension, is meant for guests too.
.add('cartothequeEntryDescription', '/cartotheque/:id/description', CartothequeEntryDescriptionPage).helper('cartothequeEntryDescription', id => app.route('cartothequeEntryDescription', {
  id
}))
// An exhibition's species for anyone, read-only - see ExpoPage.
.add('expo', '/expo/:id', ExpoPage)];